// src/components/DataTable.jsx
import React from 'react';

export default function DataTable({
  columns,
  data,
  onEdit,
  onDelete,
  idKey = 'id',
  emailSelection = false,
  selectedEmails = [],
  onToggleEmailSelection = () => {},
}) {
  if (!data || data.length === 0) {
    return <div className="no-records">No records found.</div>;
  }

  return (
    <div className="table-wrapper">
      <table className="data-table">
        <thead>
          <tr className="table-header-row">
            {columns.map((col) => (
              <th key={col.key} className="table-header-cell">
                {col.label}
              </th>
            ))}
            <th className="table-header-cell table-header-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            const emailValue = String(row.email ?? '').trim();
            const isSelected = emailSelection && emailValue ? selectedEmails.includes(emailValue) : false;

            return (
              <tr key={row[idKey]} className="table-body-row">
                {columns.map((col) => (
                  <td key={col.key} className="table-body-cell">
                    {col.render ? col.render(row[col.key], row) : String(row[col.key] ?? '')}
                  </td>
                ))}
                <td className="table-body-cell table-body-actions">
                  {emailSelection && (
                    <label className="table-email-selection">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => onToggleEmailSelection(row)}
                      />
                      <span>Email</span>
                    </label>
                  )}
                  <button onClick={() => onEdit(row)} className="btn-action-edit">Edit</button>
                  <button onClick={() => onDelete(row[idKey])} className="btn-action-delete">Delete</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}